module.exports = __webpack_public_path__ + "static/client-logo-francesco-rinaldi-da1a14dc42c921e54a2d52032b42b520.svg";